import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
    container: {
        margin: '25px',
    },
    header: {
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '10px',
        fontSize: '30px',
        textAlign: 'center',
    },
    title: {
        textDecoration: 'underline',
    },
    body: {
        marginTop: '10px',
        whiteSpace: 'pre-wrap',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        color: 'red',
    },
};
export default function ErrorOverlay(props) {
    return (_jsxs("div", { style: styles.container, children: [_jsx("p", { style: styles.header, children: "Something went wrong." }), _jsxs("details", { style: styles.body, children: [_jsx("p", { style: styles.title, children: props.error.message }), props.error.stack] })] }));
}
